// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-narrow {
  max-width: var(--content-narrow);
  margin: 0 auto;
}

.filter {
  margin-bottom: var(--spacing-half);
  display: flex;
  gap: var(--spacing-half);
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.order-table tr {
  border-bottom: 1px solid var(--ion-background-secondary-color);
}
.order-table tr td {
  padding: var(--spacing-quarter) var(--spacing-half);
  vertical-align: top;
}
.order-table tr td.status {
  text-align: center;
}
.order-table tr td.tours {
  padding: 0;
}
.order-table tr td.tours .tour {
  padding: var(--spacing-quarter) 0;
}
.order-table tr td.actions {
  text-align: right;
}
.order-table tr td.empty {
  padding: 0 var(--spacing) var(--spacing) var(--spacing-half);
}
@media (max-width: 768px) {
  .order-table tr td {
    font-size: var(--font-size-nano);
  }
  .order-table tr td.hide-mobile {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tour-consultant/orders/orders.page.scss"],"names":[],"mappings":"AACA;EACI,gCAAA;EACA,cAAA;AAAJ;;AAGA;EACI,kCAAA;EACA,aAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;AAAJ;AAEI;EACI,8DAAA;AAAR;AAEQ;EACI,mDAAA;EACA,mBAAA;AAAZ;AAEY;EACI,kBAAA;AAAhB;AAGY;EACI,UAAA;AADhB;AAGgB;EACI,iCAAA;AADpB;AAKY;EACI,iBAAA;AAHhB;AAMY;EACI,4DAAA;AAJhB;AAQY;EAzBJ;IA0BQ,gCAAA;EALd;EAOc;IACI,aAAA;EALlB;AACF","sourcesContent":["\n.content-narrow {\n    max-width: var(--content-narrow);\n    margin: 0 auto;\n}\n\n.filter {\n    margin-bottom: var(--spacing-half);\n    display: flex;\n    gap: var(--spacing-half);\n}\n\n.order-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n\n    tr {\n        border-bottom: 1px solid var(--ion-background-secondary-color);\n\n        td {\n            padding: var(--spacing-quarter) var(--spacing-half);\n            vertical-align: top;\n\n            &.status {\n                text-align: center;\n            }\n\n            &.tours {\n                padding: 0;\n\n                .tour {\n                    padding: var(--spacing-quarter) 0;\n                }\n            }\n\n            &.actions {\n                text-align: right;\n            }\n\n            &.empty {\n                padding: 0 var(--spacing) var(--spacing) var(--spacing-half);\n            }\n\n\n            @media (max-width: 768px) {\n                font-size: var(--font-size-nano);\n\n                &.hide-mobile {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
